<div class="relative py-10 sm:py-12 md:py-16 lg:py-20 xl:py-24 2xl:py-28">
    <div class="wrapper">
        <div class="max-w-[450px] sm:max-w-[470px] md:max-w-[500px] lg:max-w-[550px] w-full mx-auto">
            <img src="./assets/images/thank_you.png" alt="" class="block w-full">
        </div>
        <h1 class="w-full text-center">Thank You for Joining Teachmate!</h1>
        <h3 class="text-lg md:text-xl text-dark font-medium text-center mt-3.5">Your profile is currently under verification. Please wait for admin approval before you can access tutor features.</h3>
    </div>
</div>